import { schoolConfig } from 'src/app/core/config';

export const SCHOOL_LOGO_PATH = schoolConfig.school_logo_path;
